import PropTypes from 'prop-types';
import React from 'react';
import dynamic from 'next/dynamic';
import StyledLogoWall from './logoWall.style';

const Image = dynamic(() => import('../../atoms/image/image'));

const LogoWall = ({ logos }) => (
  <StyledLogoWall logos={logos}>
    <div className="logo-wall__grid">
      {logos.map(logo => (
        <Image
          alt={logo.alt}
          src={logo.src}
          key={logo.alt}
          className="logo-wall__logo"
          lazy="default"
        />
      ))}
    </div>
  </StyledLogoWall>
);

LogoWall.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      alt: PropTypes.string
    })
  ).isRequired
};

export default LogoWall;
